
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11068_56547)","fill":"#3C464F"}},[_c('path',{attrs:{"d":"M6.443 1.74c.322.32.514.773.514 1.225v2.687c0 1.2-.974 2.174-2.174 2.174h-2.61C.974 7.826 0 6.852 0 5.652V2.174C0 .974.974 0 2.174 0H3.99c.461 0 .905.183 1.226.513l1.226 1.226zM16.087 10.435c-2.304 0-3.913.539-3.913 1.304v2.104c.191.235 1.27.94 3.913.94s3.722-.705 3.913-.94V11.74c0-.765-1.609-1.304-3.913-1.304zM12.174 15.844v2.27c0 1.2 1.426 1.886 3.913 1.886S20 19.313 20 18.113v-2.27c-.94.41-2.235.679-3.913.679s-2.974-.27-3.913-.678zM14.418 6.244l-1.01 1.008a.257.257 0 000 .357c.044.043.105.07.157.07l3.548.234c.14.009.261-.096.27-.235v-3.8a.252.252 0 00-.426-.182l-1.01 1.008-2.19-2.19a2.926 2.926 0 00-4.14 0 .257.257 0 000 .356.23.23 0 00.192.07c.739-.07 1.47.19 2.009.704l2.6 2.6zM7.435 17.478a2.9 2.9 0 002.07-.86.257.257 0 000-.357.23.23 0 00-.192-.07c-.739.07-1.47-.191-2-.704l-2.6-2.6 1.009-1.009a.257.257 0 000-.356.234.234 0 00-.157-.07l-3.548-.235a.253.253 0 00-.27.235v3.8a.252.252 0 00.427.183l1.009-1.009 2.191 2.191c.548.548 1.296.861 2.07.861h-.01z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11068_56547"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    